import { z } from 'zod';
// Sub-case sections. Currently only IB case 7 (rare_earth_nafta) uses these.
// Other cases pass `null`. New sectioned cases must extend this union here.
export const SECTION_VALUES = ['rare_earth', 'nafta'];
export const SectionSchema = z.enum(SECTION_VALUES).nullable();
//# sourceMappingURL=section.js.map